"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpItem = void 0;
const phaser_1 = __importDefault(require("phaser"));
const roundrectangle_js_1 = __importDefault(require("phaser3-rex-plugins/plugins/roundrectangle.js"));
const ColorPalette_1 = require("../../constants/ColorPalette");
const EventConst_1 = require("../../constants/EventConst");
const TextureKeys_1 = require("../../constants/TextureKeys");
const Utils_1 = require("../../utils/Utils");
const Fonts_1 = require("../../constants/Fonts");
class HelpItem extends phaser_1.default.GameObjects.Container {
    constructor(scene, startY, itemData) {
        super(scene);
        this.listAnswerText = [];
        this.startY = startY;
        this.itemData = itemData;
        const scale = Utils_1.Utils.scale;
        const gameWidth = this.scene.scale.width;
        this.paddingX = 80 * scale;
        this.itemWidth = gameWidth * 0.87;
        this.buildItem();
        // Make item above tile sprite background
        this.setDepth(5);
        scene.add.existing(this);
    }
    buildItem() {
        const gameWidth = this.scene.scale.width;
        const scale = Utils_1.Utils.scale;
        this.title = this.scene.add
            .text(this.paddingX, this.startY + 30 * scale, this.itemData.question, {
            fontFamily: Fonts_1.Fonts.black,
            fontSize: 32 * scale,
            color: ColorPalette_1.ColorPalette.HelpButtonTitle,
            wordWrap: {
                width: this.itemWidth * 0.8,
                useAdvancedWrap: true,
            },
        })
            .setLineSpacing(5 * scale)
            .setOrigin(0);
        const arrowIcon = this.scene.add
            .image(gameWidth - this.paddingX, this.title.getCenter().y, TextureKeys_1.TextureKeys.HelpUI, 'arrow')
            .setFlipY(this.itemData.isOpen)
            .setOrigin(1, 0.5)
            .setScale(scale);
        if (this.itemData.isOpen) {
            this.buildAnswerArea();
            const firstAnswer = this.listAnswerText[0];
            const lastAnswer = this.listAnswerText[this.listAnswerText.length - 1];
            this.answerHeight =
                lastAnswer.getBottomCenter().y - firstAnswer.getTopCenter().y;
        }
        this.roundBox = new roundrectangle_js_1.default(this.scene, gameWidth / 2, this.startY, this.itemWidth, this.title.displayHeight +
            60 * scale +
            (this.itemData.isOpen ? this.answerHeight + 60 * scale : 0), 24 * scale, ColorPalette_1.Colors.HelpButtonBase, 1).setOrigin(0.5, 0);
        this.shadow = new roundrectangle_js_1.default(this.scene, gameWidth / 2, this.startY - 7 * scale, this.itemWidth + 13 * scale, this.roundBox.displayHeight + 22 * scale, 29 * scale, ColorPalette_1.Colors.BrownOffset, 1).setOrigin(0.5, 0);
        this.add([this.shadow, this.roundBox, this.title, arrowIcon]);
        if (this.itemData.isOpen) {
            this.add(this.listAnswerText);
            this.add(this.dashedLine);
        }
        this.addClickEvent();
    }
    /**
     * Build answer area if the item is open
     */
    buildAnswerArea() {
        const gameWidth = this.scene.scale.width;
        const scale = Utils_1.Utils.scale;
        // render dashed line
        this.dashedLine = new phaser_1.default.GameObjects.Container(this.scene);
        const yCoordinateLine = this.title.getBottomCenter().y + 30 * scale;
        const line = new phaser_1.default.Geom.Line(52 * scale, yCoordinateLine, gameWidth - 52 * scale, yCoordinateLine);
        const points = line.getPoints(30);
        for (let i = 0; i < points.length; i++) {
            const p = points[i];
            const rect = this.scene.add
                .rectangle(p.x, p.y, 15 * scale, 4 * scale, ColorPalette_1.Colors.BrownOffset)
                .setOrigin(0, 0.5);
            this.dashedLine.add(rect);
        }
        // Answer
        this.itemData.answer.forEach((item, index) => {
            const text = this.scene.add
                .text(90 * scale, index === 0
                ? this.title.getBottomCenter().y + 60 * scale
                : this.listAnswerText[index - 1].getBottomCenter().y + 10 * scale, item, {
                fontFamily: Fonts_1.Fonts.default,
                fontSize: 26 * scale,
                color: ColorPalette_1.ColorPalette.BrownHelpAnswer,
                wordWrap: {
                    width: this.itemWidth * 0.9,
                    useAdvancedWrap: true,
                },
            })
                .setOrigin(0);
            this.listAnswerText.push(text);
        });
    }
    /**
     * Add click event handler for item
     */
    addClickEvent() {
        this.roundBox.setInteractive();
        this.roundBox.off('pointerdown');
        this.roundBox.on('pointerdown', () => {
            const clickUpEvent = (pointer) => {
                this.roundBox.off('pointerup', clickUpEvent);
                const deltaX = Math.abs(pointer.upX - pointer.downX);
                const deltaY = Math.abs(pointer.upY - pointer.downY);
                if (deltaX > 5 || deltaY > 5) {
                    return;
                }
                this.itemData.isOpen = !this.itemData.isOpen;
                this.scene.events.emit(EventConst_1.Events.RefreshHelpMenu);
            };
            this.roundBox.off('pointerup');
            this.roundBox.on('pointerup', clickUpEvent);
        });
    }
}
exports.HelpItem = HelpItem;
